module.exports = __webpack_public_path__ + "static/img/honor.66b4f26f.png";